import PaymentTabs from "./PaymentTabs";
import React from "react";

const PaiementSFS = () => {
  return <PaymentTabs />;
};

export default PaiementSFS;